/**
 * Заголовок вкладки карточки персонажа собирают два независимых места — резолвер маршрута и эффект
 * компонента. Формула живёт здесь, чтобы они не могли разойтись; суффикс приходит параметром, потому
 * что конфигурация окружения этому слою не видна.
 */
export function buildCharacterPageTitle(publicName: string, titleSuffix: string): string {
  return `${publicName}${titleSuffix}`;
}
